import { getBrowserSupabaseClient } from "@west-tennessee-consulting/supabase";
import { Client, CreateContactForm as CreateContactFormType } from "@/lib/types/database";

export const fetchContactByEmail = async (email: string): Promise<Client | null> => {
  const supabase = getBrowserSupabaseClient();
  const { data, error } = await supabase
    .from("contacts")
    .select("*")
    .or(`email.eq.${email},email_aliases.cs.{"${email}"}`)
    .single();

  if (error && error.code !== "PGRST116") {
    // PGRST116 means no rows found, which is not an error in this case.
    throw error;
  }

  return data;
};

export const createContact = async (contactData: CreateContactFormType): Promise<Client> => {
  const supabase = getBrowserSupabaseClient();

  // Use RPC function to bypass generated column issues with Supabase's auto-generated schema
  const { data: createdContactArray, error } = await supabase.rpc("insert_contact", {
    p_name: contactData.name,
    p_email: contactData.email,
    p_company_id: contactData.company_id || null,
    p_status: contactData.status || "lead",
    p_is_active: contactData.is_active !== false,
    p_source: contactData.source || "ui:contact-popover",
    p_title: contactData.title || null,
    p_tags: contactData.tags || null,
    p_notes: contactData.notes || null,
    p_social_links: contactData.social_links || null,
  });

  if (error || !createdContactArray || createdContactArray.length === 0) {
    throw error || new Error("Failed to create contact");
  }

  return createdContactArray[0] as Client;
};

export const updateContact = async (
  contactData: CreateContactFormType,
  contactId: string
): Promise<Client> => {
  const supabase = getBrowserSupabaseClient();
  const { data, error } = await supabase
    .from("contacts")
    .update(contactData)
    .eq("id", contactId)
    .single();

  if (error) {
    throw error;
  }

  return data;
};
